var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"icon-home",on:{"click":_vm.toHome}},[_c('div',{staticClass:"icon-home-image"})]),_c('FilterNav'),(_vm.isResult)?_c('Result'):_c('Sheets')],1)}
var staticRenderFns = []

export { render, staticRenderFns }